import React from 'react';
import DOMPurify from 'dompurify';

interface HtmlPreviewProps {
  htmlContent: string;
  title?: string;
}

const HtmlPreview: React.FC<HtmlPreviewProps> = ({ htmlContent, title }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-medium text-gray-700">Preview</h3>
        <span className="text-xs text-gray-500">How it will appear in the mobile app</span>
      </div>
      
      {/* Mobile app mockup */}
      <div className="bg-gray-50 rounded-lg p-4 border-2 border-dashed border-gray-300">
        {title && (
          <h4 className="font-semibold text-gray-900 mb-2">{title}</h4>
        )}
        <div 
          className="prose prose-sm max-w-none"
          dangerouslySetInnerHTML={{ 
            __html: DOMPurify.sanitize(htmlContent) || '<p class="text-gray-400 italic">No content to preview</p>' 
          }}
        />
      </div>
      
      <p className="text-xs text-gray-500 mt-2">
        This is a simplified preview. The actual appearance may vary slightly based on the mobile app's styling.
      </p>
    </div>
  );
};

export default HtmlPreview;